import { brandingDefinitions } from './brandingDefinitions.js'

export const headerTexts = {
  mixins: [brandingDefinitions],
  data() {
    return {
      subheaderMap: {
        overview: 'subheader',
      },
      headerMap: {
        overview: 'header',
      },
      headerTextDefaults: {
        overview: {
          header: "It's all about trust",
          subheader: 'Discover how we protect your data.',
        },
      },
    }
  },
  methods: {
    // Find page definition by prefix (type), handling section/page suffixes
    findPageDefinitionByPrefix(type) {
      // First try exact match
      let pageDefinition = this.brandingDefinitions.pages.find(
        (page) => page.prefix === type
      )
      if (pageDefinition) return pageDefinition

      let aboutDefinition =
        this.brandingDefinitions.aboutAndCertifications.find(
          (item) => item.prefix === type
        )
      if (aboutDefinition) return aboutDefinition

      // Check all definitions for standard patterns and exceptions
      const allDefinitions = [
        ...this.brandingDefinitions.pages,
        ...this.brandingDefinitions.aboutAndCertifications,
      ]

      for (const definition of allDefinitions) {
        // Check for standard Page pattern: prefix + 'Page'
        if (type.endsWith('Page')) {
          const expectedPageName = definition.prefix + 'Page'
          if (type === expectedPageName) {
            return definition
          }

          // Check page alias/aliases exceptions
          if (definition.page) {
            if (definition.page.alias === type) {
              return definition
            }
            if (
              definition.page.aliases &&
              definition.page.aliases.includes(type)
            ) {
              return definition
            }
          }
        }

        // Check for standard Section pattern: prefix + 'Section'
        if (type.endsWith('Section')) {
          const expectedSectionName = definition.prefix + 'Section'
          if (type === expectedSectionName) {
            return definition
          }

          // Check section alias/aliases exceptions
          if (definition.section) {
            if (definition.section.alias === type) {
              return definition
            }
            if (
              definition.section.aliases &&
              definition.section.aliases.includes(type)
            ) {
              return definition
            }
          }
        }
      }

      return null
    },

    // Find page definition by legacy key (when key ends with Header or Subheader)
    findPageDefinitionByLegacyKey(key) {
      const isHeader = key.endsWith('Header')
      const isSubheader = key.endsWith('Subheader')
      const isPage = key.includes('Page')

      if (!isHeader && !isSubheader) return null

      // Search in all page definitions
      const allDefinitions = [
        ...this.brandingDefinitions.pages,
        ...this.brandingDefinitions.aboutAndCertifications,
      ]
      // console.log('Inside findPageDefinitionByLegacyKey - key, allDefinitions:', key, allDefinitions)
      for (const definition of allDefinitions) {
        // Check if key matches prefix + Header/Subheader pattern
        let prefix =
          definition?.legacyNames?.pageHeaderPrefix || definition.prefix
        const expectedKey =
          prefix + (isPage ? 'Page' : '') + (isHeader ? 'Header' : 'Subheader')
        if (key === expectedKey) {
          return definition
        }

        // Check legacy names
        if (definition.legacyNames) {
          for (const [legacyType, legacyKey] of Object.entries(
            definition.legacyNames
          )) {
            if (legacyKey === key) {
              return definition
            }
          }
        }
      }

      return null
    },

    getBrandingPathForHeaderText(type, textKey = 'subheader') {
      const pageDefinition = this.findPageDefinitionByPrefix(type)

      if (!pageDefinition) {
        // Fallback to old logic for types not in brandingDefinitions
        if (textKey === 'header' && this.headerMap[type]) {
          return `overview.${this.headerMap[type]}`
        }
        if (textKey === 'subheader' && this.subheaderMap[type]) {
          return `overview.${this.subheaderMap[type]}`
        }
        return null
      }

      // Use prefix to build branding path
      const prefix = pageDefinition.prefix
      if (textKey === 'header') {
        return `overview.${prefix}Header`
      }
      if (textKey === 'subheader') {
        return `overview.${prefix}Subheader`
      }

      return null
    },

    getHeaderText(type, textKey = 'header') {
      const brandingPath = this.getBrandingPathForHeaderText(type, textKey)
      const brandingValue = brandingPath
        ? _.get(this.getBrending, brandingPath)
        : undefined

      // Try brandingDefinitions first
      const pageDefinition = this.findPageDefinitionByPrefix(type)
      let defaultValue

      if (pageDefinition && pageDefinition.defaultText) {
        if (type.includes('Page')) {
          defaultValue =
            pageDefinition.defaultText[
              `page${textKey.charAt(0).toUpperCase() + textKey.slice(1)}`
            ] || pageDefinition.defaultText[textKey]
        } else {
          defaultValue = pageDefinition.defaultText[textKey]
        }
      } else {
        // Fallback to old headerTextDefaults
        defaultValue = _.get(this.headerTextDefaults, `${type}.${textKey}`)
      }

      if (brandingValue === undefined) {
        return defaultValue
      }

      return brandingValue
    },

    getDefaultTextBySubheaderKey(key) {
      const pageDefinition = this.findPageDefinitionByLegacyKey(key)

      if (pageDefinition && pageDefinition.defaultText) {
        // Determine if it's a page subheader or section subheader
        return pageDefinition.defaultText.subheader
      }

      // Fallback to old logic
      const type = Object.keys(this.subheaderMap).find(
        (k) => this.subheaderMap[k] === key
      )
      if (type) {
        return this.headerTextDefaults[type]?.subheader
      }
      return ''
    },

    getDefaultTextByHeaderKey(key) {
      const pageDefinition = this.findPageDefinitionByLegacyKey(key)
      // console.log('Inside getDefaultTextByHeaderKey - key, pageDefinition, pageDefinition?.defaultText:', key, pageDefinition, pageDefinition?.defaultText)

      if (pageDefinition && pageDefinition.defaultText) {
        // Determine if it's a page header or section header
        return pageDefinition.defaultText.header
      }

      // Fallback to old logic
      const type = Object.keys(this.headerMap).find(
        (k) => this.headerMap[k] === key
      )
      if (type) {
        return this.headerTextDefaults[type]?.header
      }
      return ''
    },
  },
}
